import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-md/dist/react-md.amber-indigo.min.css';

import App from './App';
import store from './store';

import './normalize.css';
import './index.css';

// Install global handlers to capture unhandled promise rejections and errors
// This helps debugging in development — will print full reason/stack to console
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    // event.reason can be an Error or any value
    // Log as much as possible so we can identify the source
    // eslint-disable-next-line no-console
    console.error('Unhandled promise rejection:', event.reason, event);
  });

  window.addEventListener('error', (event) => {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', event.error || event.message, event);
  });
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  // Service worker registration intentionally disabled for debugging
  // import registerServiceWorker from './registerServiceWorker';
  document.getElementById('root')
);
// registerServiceWorker();
